<div class="cart-item-card">
  <div class="item-main-info">
    @if(item.bookCoverURL){
    <img class="item-image" [src]="item.bookCoverURL" [alt]="item.bookTitle">
    } @else{
    <img class="item-image" src="https://placehold.co/80x120/e0e0e0/333?text=Capa" [alt]="item.bookTitle">
    }

    <div class="item-details">
      <div class="item-title">{{ item.bookTitle }}</div>
      <div class="item-type">
        <span *ngIf="item.includesEbook">ebook</span>
        <span *ngIf="item.includesBook"> - físico</span>
        <span *ngIf="item.includesVideoAccess"> - video aula</span>
      </div>
      <div class="item-author">by {{ item.author }}</div>
    </div>
  </div>

  <div class="item-quantity-control" *ngIf="item.includesBook">
    <button mat-icon-button (click)="decrementQuantity()">
      <mat-icon>remove</mat-icon>
    </button>
    <span>{{ item.quantity }}</span>
    <button mat-icon-button (click)="incrementQuantity()">
      <mat-icon>add</mat-icon>
    </button>
  </div>

  <div class="item-quantity-control" *ngIf="!item.includesBook">
    <button mat-button class="with-label" (click)="decrementQuantity()">
      <mat-icon>delete</mat-icon> remover
    </button>
  </div>

  <div class="item-pricing">
    <div class="price-row total">
      <span>{{ item.totalPrice | currency:'BRL' }}</span>
    </div>
  </div>
</div>